import { render } from "./Home.vue?vue&type=template&id=56a9086c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=56a9086c&scoped=true&lang=css"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a9086c"]])

export default __exports__